import * as keyapis_subscription_v1_events_pb from "./v1/keyapis_subscription_events_v1.pb";
import * as keyapis_subscription_v1_offer_pb from "./v1/keyapis_subscription_offer_v1.pb";
import * as keyapis_subscription_v1_plan_pb from "./v1/keyapis_subscription_plan_v1.pb";
import * as keyapis_subscription_v1_privilege_pb from "./v1/keyapis_subscription_privilege_v1.pb";
import * as keyapis_subscription_v1_service_pb from "./v1/keyapis_subscription_service_v1.pb";
import * as keyapis_subscription_v1_subscription_pb from "./v1/keyapis_subscription_subscription_v1.pb";
import * as keyapis_subscription_v1_system_pb from "./v1/keyapis_subscription_system_v1.pb";

export default {
  v1: {
    resources: {
      events: keyapis_subscription_v1_events_pb,
      offer: keyapis_subscription_v1_offer_pb,
      plan: keyapis_subscription_v1_plan_pb,
      privilege: keyapis_subscription_v1_privilege_pb,
      service: keyapis_subscription_v1_service_pb,
      subscription: keyapis_subscription_v1_subscription_pb,
      system: keyapis_subscription_v1_system_pb,
    },
  },
};
